/* eslint-disable react-refresh/only-export-components */
import { Link, useLocation } from 'react-router-dom';
import rightArrow from '../assets/right_arrow.png';

const ROUTE_CRUMBS = {
  '/dashboard': [{ label: 'Home', path: '/dashboard' }, { label: 'Overview' }],
  '/not-found': [
    { label: 'Home', path: '/dashboard' },
    { label: 'Page Not Found' },
  ],
  '/contacts': [{ label: 'Home', path: '/dashboard' }, { label: 'Contacts' }],
  '/templates': [{ label: 'Home', path: '/dashboard' }, { label: 'Templates' }],
  '/email-templates': [
    { label: 'Home', path: '/dashboard' },
    { label: 'Templates' },
  ],
  '/campaigns': [{ label: 'Home', path: '/dashboard' }, { label: 'Campaigns' }],
  '/email-campaigns': [
    { label: 'Home', path: '/dashboard' },
    { label: 'Campaigns' },
  ],
  '/whatsapp-chat': [{ label: 'Home', path: '/dashboard' }, { label: 'Inbox' }],
  '/email-inbox': [{ label: 'Home', path: '/dashboard' }, { label: 'Inbox' }],
  '/employees': [{ label: 'Home', path: '/dashboard' }, { label: 'Employees' }],
  '/whatsapp-flows': [
    { label: 'Home', path: '/dashboard' },
    { label: 'Automations' },
  ],
  '/crm-dashboard': [
    { label: 'Home', path: '/dashboard' },
    { label: 'CRM', path: '/crm-dashboard' },
    { label: 'CRM Dashboard' },
  ],
  '/crm-dashboard/task': [
    { label: 'Home', path: '/dashboard' },
    { label: 'CRM', path: '/crm-dashboard' },
    { label: 'CRM Dashboard', path: '/crm-dashboard' },
    { label: 'Task' },
  ],
  '/crm-dashboard/followup': [
    { label: 'Home', path: '/dashboard' },
    { label: 'CRM', path: '/crm-dashboard' },
    { label: 'CRM Dashboard', path: '/crm-dashboard' },
    { label: 'Follow-up' },
  ],
  '/crm-contacts': [
    { label: 'Home', path: '/dashboard' },
    { label: 'CRM', path: '/crm-dashboard' },
    { label: 'Leads' },
  ],
  '/crm-contacts/overview': [
    { label: 'Home', path: '/dashboard' },
    { label: 'CRM', path: '/crm-dashboard' },
    { label: 'Leads', path: '/crm-contacts' },
    { label: 'Overview' },
  ],
  '/crm-pipeline': [
    { label: 'Home', path: '/dashboard' },
    { label: 'CRM', path: '/crm-dashboard' },
    { label: 'Inquiries' },
  ],
  '/crm-pipeline/settings': [
    { label: 'Home', path: '/dashboard' },
    { label: 'CRM', path: '/crm-dashboard' },
    { label: 'Inquiries', path: '/crm-pipeline' },
    { label: 'Settings' },
  ],
  '/crm-segments': [
    { label: 'Home', path: '/dashboard' },
    { label: 'CRM', path: '/crm-dashboard' },
    { label: 'Groups' },
  ],
  '/reminders': [
    { label: 'Home', path: '/dashboard' },
    { label: 'CRM', path: '/crm-dashboard' },
    { label: 'Reminders' },
  ],
  '/reminders/import': [
    { label: 'Home', path: '/dashboard' },
    { label: 'CRM', path: '/crm-dashboard' },
    { label: 'Reminders', path: '/reminders' },
    { label: 'Import Reminders' },
  ],
  '/calendar': [
    { label: 'Home', path: '/dashboard' },
    { label: 'Appointments' },
  ],
  '/calendar/availability': [
    { label: 'Home', path: '/dashboard' },
    { label: 'Appointments', path: '/calendar' },
    { label: 'Booking Availability' },
  ],
  '/ecommerce': [
    { label: 'Home', path: '/dashboard' },
    { label: 'E-commerce' },
  ],
  '/task': [{ label: 'Home', path: '/dashboard' }, { label: 'Task' }],
  '/crm-settings': [
    { label: 'Home', path: '/dashboard' },
    { label: 'CRM', path: '/crm-dashboard' },
    { label: 'Configuration' },
  ],
  '/integrations': [
    { label: 'Home', path: '/dashboard' },
    { label: 'General' },
    { label: 'Integrations' },
  ],
  '/profile': [{ label: 'Home', path: '/dashboard' }, { label: 'Profile' }],
  '/settings': [{ label: 'Home', path: '/dashboard' }, { label: 'Settings' }],
  '/settings/feedback': [
    { label: 'Home', path: '/dashboard' },
    { label: 'General' },
    { label: 'Feedback' },
  ],
  '/quotations': [
    { label: 'Home', path: '/dashboard' },
    { label: 'Quotations' },
  ],
};

function resolveCrumbs(pathname, locationState, search) {
  if (
    pathname === '/crm-contacts/overview' &&
    locationState?.from?.startsWith('/crm-pipeline')
  ) {
    return [
      { label: 'Home', path: '/dashboard' },
      { label: 'CRM', path: '/crm-dashboard' },
      { label: 'Inquiries', path: '/crm-pipeline' },
      { label: 'Overview' },
    ];
  }

  if (
    pathname === '/crm-contacts/overview' &&
    locationState?.from?.startsWith('/calendar')
  ) {
    return [
      { label: 'Home', path: '/dashboard' },
      { label: 'Appointments', path: '/calendar' },
      { label: 'Overview' },
    ];
  }

  if (pathname === '/calendar/availability') {
    let tabLabel = 'Booking Settings';
    if (search) {
      const searchParams = new URLSearchParams(search);
      if (searchParams.get('tab') === 'reminders') {
        tabLabel = 'WhatsApp Appointment Reminders';
      }
    }
    return [
      { label: 'Home', path: '/dashboard' },
      { label: 'Appointments', path: '/calendar' },
      { label: tabLabel },
    ];
  }

  if (pathname === '/not-found' && locationState?.unavailable === 'card') {
    return [{ label: 'Home', path: '/dashboard' }, { label: 'Unavailable' }];
  }

  if (ROUTE_CRUMBS[pathname]) return ROUTE_CRUMBS[pathname];

  if (pathname.startsWith('/campaigns/')) {
    return [
      { label: 'Home', path: '/dashboard' },
      { label: 'Campaigns', path: '/campaigns' },
      { label: 'Campaign Log' },
    ];
  }

  if (pathname.startsWith('/email-campaigns/')) {
    return [
      { label: 'Home', path: '/dashboard' },
      { label: 'Campaigns', path: '/email-campaigns' },
      { label: 'Campaign Log' },
    ];
  }

  if (pathname.startsWith('/reminders/import/')) {
    return [
      { label: 'Home', path: '/dashboard' },
      { label: 'CRM', path: '/crm-dashboard' },
      { label: 'Reminders', path: '/reminders' },
      { label: 'Import Job' },
    ];
  }

  if (pathname.startsWith('/integrations/')) {
    const parts = pathname.split('/').filter(Boolean);
    const crumbs = [
      { label: 'Home', path: '/dashboard' },
      { label: 'General' },
      { label: 'Integrations', path: '/integrations' },
    ];
    if (parts.includes('history')) {
      crumbs.push({ label: 'History' });
    } else {
      crumbs.push({ label: 'Details' });
    }
    return crumbs;
  }

  if (pathname.startsWith('/quotations/')) {
    const parts = pathname.split('/').filter(Boolean);
    const crumbs = [
      { label: 'Home', path: '/dashboard' },
      { label: 'Quotations', path: '/quotations' },
    ];

    if (parts.includes('products')) {
      if (parts.includes('create')) {
        crumbs.push({ label: 'Add Product' });
      } else if (parts.includes('edit')) {
        crumbs.push({ label: 'Edit Product' });
      } else {
        crumbs.push({ label: 'Product Details' });
      }
    } else {
      if (parts.includes('edit')) {
        crumbs.push({ label: 'Edit Quotation' });
      } else if (parts.includes('share') || parts.includes('customer')) {
        const customerName =
          locationState?.customerName ||
          (typeof sessionStorage !== 'undefined'
            ? sessionStorage.getItem('quotation-customer-name')
            : '') ||
          '';
        crumbs.push({ label: customerName || 'Customer Quotation' });
      } else {
        crumbs.push({ label: 'Quotation Details' });
      }
    }
    return crumbs;
  }

  return [{ label: 'Home', path: '/dashboard' }];
}

export function getActivePageTitle(pathname, locationState, search) {
  const crumbs = resolveCrumbs(pathname, locationState, search);
  return crumbs[crumbs.length - 1]?.label || 'Overview';
}

export default function Breadcrumbs() {
  const { pathname, state, search } = useLocation();
  const crumbs = resolveCrumbs(pathname, state, search);

  return (
    <nav
      aria-label="Breadcrumb"
      className="flex items-center flex-wrap gap-1.5 px-2 text-[14px] leading-[20px] font-medium font-sf-pro-display"
    >
      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1;

        return (
          <span
            key={`${crumb.label}-${index}`}
            className="flex items-center gap-1.5"
          >
            {index > 0 && (
              <img
                src={rightArrow}
                alt=""
                aria-hidden
                className="w-3 h-3 object-contain"
              />
            )}
            {crumb.path && !isLast ? (
              <Link
                to={crumb.path}
                className="text-text-secondary hover:text-primary transition-colors"
              >
                {crumb.label}
              </Link>
            ) : (
              <span
                className={isLast ? 'text-primary' : 'text-text-secondary'}
                aria-current={isLast ? 'page' : undefined}
              >
                {crumb.label}
              </span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
